import { render } from "./inicio_ingles.vue?vue&type=template&id=469de184&scoped=true"
import script from "./inicio_ingles.vue?vue&type=script&lang=js"
export * from "./inicio_ingles.vue?vue&type=script&lang=js"

import "./inicio_ingles.vue?vue&type=style&index=0&id=469de184&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-469de184"]])

export default __exports__